import React from 'react';

// Light-theme health summary strip shown at the top of the infrastructure
// section. It surfaces the same status counts the tiles below carry, the number
// of alarms currently in the ALARM state, and the client-side "scanned at"
// timestamp.
//
// All values are passed in via `summary` (see computeInfraSummary) so this stays
// a pure presentational component with no network calls of its own.
const formatScannedAt = (lastUpdated) => {
  if (!lastUpdated) return '—';
  try {
    return lastUpdated.toLocaleTimeString('en-US', {
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: true,
    });
  } catch (e) {
    return '—';
  }
};

const InfraHealthSummary = ({ summary, lastUpdated, loading }) => {
  const s = summary || {
    critical: 0,
    warning: 0,
    healthy: 0,
    partial: 0,
    alarmsInAlarm: 0,
  };

  const chips = [
    { key: 'critical', label: 'Critical', value: s.critical, cls: 'critical' },
    { key: 'warning', label: 'Warning', value: s.warning, cls: 'warning' },
    { key: 'healthy', label: 'Healthy', value: s.healthy, cls: 'healthy' },
    { key: 'partial', label: 'Partial', value: s.partial, cls: 'partial' },
  ];

  return (
    <div
      className="infra-health-summary"
      role="group"
      aria-label="Infrastructure health summary"
    >
      <div className="infra-summary-chips">
        {chips.map((chip) => (
          <div
            key={chip.key}
            className={`infra-summary-chip ${chip.cls}`}
            aria-label={`${chip.label}: ${loading ? 'loading' : chip.value} services`}
          >
            <span className="chip-dot" aria-hidden="true" />
            <span className="chip-value">{loading ? '—' : chip.value}</span>
            <span className="chip-label">{chip.label}</span>
          </div>
        ))}
      </div>

      <div className="infra-summary-meta">
        <div
          className={`infra-summary-metric ${!loading && s.alarmsInAlarm > 0 ? 'has-alarms' : ''}`}
          aria-label={`Alarms in alarm state: ${loading ? 'loading' : s.alarmsInAlarm}`}
        >
          <span className="meta-label">In Alarm</span>
          <span className="meta-value">{loading ? '—' : s.alarmsInAlarm}</span>
        </div>
        <div className="infra-summary-metric" aria-label={`Last scanned at ${formatScannedAt(lastUpdated)}`}>
          <span className="meta-label">Scanned At</span>
          <span className="meta-value">{loading ? 'Loading…' : formatScannedAt(lastUpdated)}</span>
        </div>
      </div>
    </div>
  );
};

export default InfraHealthSummary;
